
import { FormattedMessage } from 'react-intl';
import { Button, Tabs } from 'antd';
import ArticlesTab from './ArticlesTab/ArticlesTab';
import Icon from '../../components/Icon/Icon';
import ProfileCard from '../../components/Cards/ProfileCard';
import ProfileTab from './ProfileTab/ProfileTab';
import Reviews from '../../components/Reviews/Reviews';
import NetworkTab from './NetworkTab/NetworkTab';
import UserAverageRating from '../../components/UserAverageRating/UserAverageRating';
import useUserProfile from './useMyProfile';
import styles from './MyProfile.module.scss';
import OrcidArticleSelection from '../../components/OrcidArticleSelection/OrcidArticleSelection';

const MyProfile = () => {
	const { TabPane } = Tabs;

	const {
		formatDate,
		navigateTo,
		onChangeTab,
		onClickReviewer,
		onCloseOrcidPopup,
		redirectToAuthorizeOAuthURL,
		setTriggerArticlePopup,
		state,
		userId,
	} = useUserProfile();

	const {
		activeTabKey,
		averageScore,
		i18nCountries,
		orcidUserId,
		profile,
		reviews,
		showOrcidPopup,
		triggerArticlePopup
	} = state;

	const tabBarExtraContent = {
		right: (<>
			{activeTabKey === '1' && <div className={styles.tabBarExtraContent}>
				<Button size="large" type="primary" onClick={navigateTo.bind(null, '/edit-my-profile')}><FormattedMessage id="buttons.editProfile" /></Button>
			</div>}
			{activeTabKey === '2' && <div className={styles.tabBarExtraContent}>
				<Button size="large" type="primary" onClick={() => { setTriggerArticlePopup(true) }}>
					<FormattedMessage id="buttons.addArticle" />
				</Button>
				<Button className={styles.greenBtn} size="large" type="default" onClick={redirectToAuthorizeOAuthURL}>
					<Icon name="orcid" className={styles.orcidIcon} />
					<FormattedMessage id="buttons.importArticles" /></Button>
			</div>}
		</>)
	};

	const renderProfileCard = () => (
		<ProfileCard
			actions={[
				<div className={styles.actions}>
					{averageScore && <UserAverageRating score={averageScore} isCurrentUser={true} />}
					<div className={styles.availability}>
						<h3><FormattedMessage id="userProfile.availableFor" /><Icon color="text" height="8" name="chevron-right" /></h3>
						<div className={styles.iconsWrapper}>
							{profile?.isReachableByText ? <Icon color="green" name="comment-alt-lines" type="solid" /> : <Icon color="light" name="comment-alt-slash" type="solid" />}
							{profile?.isReachableByCall ? <>
								<Icon color="green" name="phone" type="solid" />
								<Icon color="green" name="video" type="solid" />
							</> : <>
								<Icon color="light" name="phone-slash" type="solid" />
								<Icon color="light" name="video-slash" type="solid" />
							</>}

						</div>
					</div>
				</div>
			]}
			fitContainer
			showData
			data={{
				currentPosition: profile?.currentPosition,
				education: profile?.education,
				imageId: profile?.imageId,
				languages: profile?.languages,
				location: profile?.location,
				name: profile?.name || '',
				pronouns: profile?.pronouns,
				researchAreas: profile?.researchAreas,
				workExperience: profile?.workExperience,
			}}>
		</ProfileCard>
	);

	return (
		<div className={styles.pageContainer}>
			<div className={`${styles.pageSider} ${styles.topBorder} ${styles.noPadding}`}>
				{profile && renderProfileCard()}
			</div>

			<div className={styles.pageContent}>
				<div className={`${styles.mobileTopper} ${styles.topBorder} ${styles.noPadding}`}>
					{profile && renderProfileCard()}
				</div>
				<div className={styles.tabBarExtraContentMobile}>
					{activeTabKey === '1' && <Button size="large" type="primary" onClick={navigateTo.bind(null, '/edit-my-profile')}>
						<FormattedMessage id="buttons.editProfile" />
					</Button>}
					{activeTabKey === '2' &&
						<>
						<Button size="large" type="primary" onClick={() => { setTriggerArticlePopup(true) }}>
							<FormattedMessage id="buttons.addArticle" />
						</Button>
						<Button className={styles.greenBtn} size="large" type="default" onClick={redirectToAuthorizeOAuthURL}>
							<Icon name="orcid" className={styles.orcidIcon} />
							<FormattedMessage id="buttons.importArticles" /></Button>
						</>
					}
				</div>
				{profile && <div className={styles.content}>
					<Tabs
						activeKey={activeTabKey}
						className="navigator"
						defaultActiveKey="1"
						tabBarExtraContent={tabBarExtraContent}
						onChange={onChangeTab}
						destroyInactiveTabPane
					>
						<TabPane
							tab={
								<>
									<span>
										<span className={styles.tabPaneName}><FormattedMessage id="navigation.my" /> </span>
										<FormattedMessage id="navigation.profile" />
									</span>
									<span className={styles.tabDivider}>/</span>
								</>
							}
							key="1"
						>
							<ProfileTab
								conference={profile.conference}
								i18nCountries={i18nCountries}
								id={userId}
								introduction={profile.introduction}
								mentoringScopes={profile.mentoringScopes}
								reviews={<Reviews onClickReviewer={onClickReviewer} reviews={reviews} />}
								formatDate={formatDate}
								role={profile.role}
								showReviews={profile.role === 'Mentor'} />
						</TabPane>
						<TabPane tab={
							<>
								<span>
									<FormattedMessage id="navigation.articles" />
								</span>
								<span className={styles.tabDivider}>/</span>
							</>
						} key="2">
							<ArticlesTab
								i18nCountries={i18nCountries}
								id={userId}
								triggerArticlePopup={{ set: setTriggerArticlePopup, value: triggerArticlePopup }} />
						</TabPane>
						<TabPane tab={
							<>
								<span>
									<FormattedMessage id="navigation.network" />
								</span>
							</>
						} key="3">
							<NetworkTab
								id={userId}
								userId={userId}
								navigateTo={navigateTo} />
						</TabPane>
					</Tabs>
				</div>}
			</div>
			{
				showOrcidPopup && orcidUserId && <OrcidArticleSelection onClose={onCloseOrcidPopup} orcidId={orcidUserId} />
			}
		</div>);
}

export default MyProfile;